import Message from "./model/Message";
import BubbleType from "./model/BubbleType";
import {
    CALL_MESSAGE_TYPE,
    CALL_STATE,
    CHAT_COMMANDS,
    CHAT_STATE,
    Constants,
    KEY_TYPE,
    MessageType,
    RICH_WIDGET,
    STATUS_STATE,
    SYSTEM_STATE, TYPING_STATE
} from "./model/Constants";
import { Timeout, decodeEntities, textGenerator } from "./util/Misc";
import { addMessageBubbleToTranscriptInChatWindow, sendDisclaimerAsDataPass, handleCommandEvent } from "./controller/TranscriptController";
import ModalMgr from "./util/ModalMgr";
import pubSubGlobal from "./util/pubSubGlobal";

const ACTIVITY_AGENT_TYPING = "2";
const ACTIVITY_AGENT_STOPPED_TYPING = "16";
/* eslint-disable no-param-reassign */
/**
 * GetMessageHandler class is responsible for handling Message response from backend.
 * Its takes appropriate action according to the message type
 */

class GetMessageHandler {
    $app: any;

    isQueued: boolean;

    agents: any[];

    statusObj: any;

    confAgents: any[];

    currentWindowId: any;

    callReconnectTimer: NodeJS.Timeout;

    /**
     * Creates GetMessageHandler
     * @param {CIApp} app - CIApp class instance
     */
    constructor(app) {
        /**
         * @type {CIApp}
         */
        this.$app = app;

        /**
         *
         * @type {boolean}
         */
        this.isQueued = false;

        /*
         * Inq.EVM.addListener({
         *  "onAgentAssigned":() => {
         *      this.aIndex ++;
         *  }
         * });
         */

        this.agents = [];
        this.statusObj = app.statusItems;
        this.confAgents = [];
        this.currentWindowId = null;
    }

    /**
     *
     * @param {com.inq.flash.messagingframework.Message} msgObj - json object that contains message information
     * @param {(true | false)} isRestoring  - depends if chat is restoring after a page reload
     */
    onNewMessage(msgObj, isRestoring, isLast) {
        const ts = parseInt(this.getProperty(msgObj, KEY_TYPE.KEY_MESSAGE_TIMESTAMP) || Date.now(), 10);
        let isOpenerType = false;

        if (msgObj) {
            /**
             *
             * @type {string} type of this message, list of message types are found in @see {@link MessageType}
             */
            const messageType = this.getProperty(msgObj, KEY_TYPE.KEY_MESSAGE_TYPE);

            switch (messageType) {
                case MessageType.TYPE_CHAT_COMMUNICATION: {
                    const text = this.getProperty(msgObj, KEY_TYPE.KEY_FINAL_TEXT);
                    const isAgentMsg = this.getProperty(msgObj, KEY_TYPE.KEY_ISAGENTMSG);
                    const msgType = isAgentMsg ? BubbleType.AGENT_MESSAGE : BubbleType.CUSTOMER_MESSAGE;

                    const timestamp = ts;

                    const senderName = this.getProperty(msgObj, KEY_TYPE.KEY_SENDER_NAME);
                    const isReplay = this.getProperty(msgObj, KEY_TYPE.CHAT_REPLAY) === "1";
                    const windowId = this.getProperty(msgObj, KEY_TYPE.KEY_WINDOW_ID);
                    const isExternalApp = this.getProperty(msgObj, KEY_TYPE.KEY_EXTERNAL_APP) === "true";

                    this.clearTypingTimeout();

                    if (isAgentMsg) {
                        if (!isRestoring) {
                            pubSubGlobal.publish("new.agentMsg", msgObj);
                        }

                        const rData = this.getDataMessage(msgObj);

                        if (rData && this.displayDataMessage(rData, text, isRestoring, false, senderName, timestamp, isLast, false, false, isExternalApp)) {
                            this.setMsgOnMinimized(isRestoring, msgObj);
                        } else if (text == Constants.EA) {
                            return;
                        } else {
                            const message = new Message({
                                messageText: text,
                                isAuto: false,
                                name: senderName,
                                timestamp: timestamp, // eslint-disable-line object-shorthand
                            });
                            if (isExternalApp) {
                                message.setExternalVA();
                            }
                            message.setRestore(isRestoring);
                            message.setIsLast(isLast);

                            this.setMsgOnMinimized(isRestoring, msgObj);

                            message.setAgentIndex(this.setAgentIndex(senderName));
                            this.$app.addToUI(message);
                        }

                        if (!isRestoring) {
                            this.$app.sndMgr.playSound();
                        }
                    } else if (isRestoring || (!isReplay && this.currentWindowId !== windowId)) {
                        if (text.startsWith(Constants.EA)) {
                            const rData = this.getDataMessage(msgObj);

                            if (rData) {
                                this.displayDataMessage(rData, text, true, false, senderName, timestamp, false, true, false, isExternalApp);
                            }
                        } else {
                            this.$app.addCustomerBubble(text, true, timestamp);
                        }
                    } else if (this.$app.getIsMinimized()) {
                        this.$app.addCustomerBubble(text, true, timestamp);
                        this.$app.getSDKInstance().resetMinimizedCount();
                    }
                }

                    break;

                case MessageType.TYPE_CHAT_COMMUNICATION_OPENER:
                    isOpenerType = true;

                // falls through
                case MessageType.TYPE_CHAT_COMMUNICATION_OUTCOME:
                    if (isRestoring) {
                        const text = this.getProperty(msgObj, KEY_TYPE.KEY_FINAL_TEXT);
                        const timestamp = ts;
                        const senderName = this.getProperty(msgObj, KEY_TYPE.KEY_SENDER_NAME);

                        if (isOpenerType && this.displayOpenerRichMessage(text, true, false, senderName, timestamp)) {
                            return;
                        }

                        const message = new Message({
                            messageText: text,
                            isAuto: false,
                            name: senderName,
                            timestamp: timestamp, // eslint-disable-line object-shorthand
                        });
                        message.setRestore(true);
                        message.setAgentIndex(this.setAgentIndex(senderName));

                        if (isOpenerType) {
                            message.setMessageBubble(BubbleType.OPENER_MESSAGE);
                        }

                        this.$app.openerText = text;
                        this.$app.addToUI(message);
                    }

                    break;

                case MessageType.TYPE_CHAT_COMMUNICATION_SURVEY: {
                    const text = this.getProperty(msgObj, KEY_TYPE.KEY_MSG_TEXT);

                    const senderName = this.getProperty(msgObj, KEY_TYPE.KEY_MSG_AGENT_ALIAS);
                    const timestamp = ts;

                    this.setMsgOnMinimized(isRestoring, msgObj);

                    const message = new Message({
                        messageText: text,
                        isAuto: false,
                        name: senderName,
                        timestamp: timestamp, // eslint-disable-line object-shorthand
                    });
                    message.setRestore(isRestoring);
                    message.setAgentIndex(this.setAgentIndex(senderName));
                    this.$app.addToUI(message);

                    if (!isRestoring) {
                        this.$app.sndMgr.playSound();
                    }
                }

                    break;

                case MessageType.TYPE_CHAT_AUTOMATON_REQUEST: {
                    this.clearTypingTimeout();

                    const text = this.getProperty(msgObj, KEY_TYPE.KEY_CHAT_AUTOMATON_DATA);

                    const senderName = this.getProperty(msgObj, KEY_TYPE.KEY_MSG_AGENT_ALIAS);
                    const timestamp = ts;
                    const rData = this.getDataMessage(msgObj);

                    if (rData && this.displayDataMessage(rData, text, isRestoring, true, senderName, timestamp, isLast)) {
                        // eslint-disable-line  no-empty
                    } else {
                        const message = new Message({
                            bubbleType: BubbleType.VIRTUAL_AGENT_MESSAGE,
                            messageText: text,
                            isAuto: true,
                            name: senderName,
                            timestamp: timestamp, // eslint-disable-line object-shorthand
                        });

                        message.setRestore(isRestoring);
                        message.setIsLast(isLast);

                        message.setAgentIndex(this.setAgentIndex(senderName));

                        this.setMsgOnMinimized(isRestoring, message);

                        this.$app.addToUI(message);
                    }

                    if (!isRestoring) {
                        this.$app.sndMgr.playSound();
                    }
                }

                    break;

                case MessageType.TYPE_CHAT_ACTIVITY:
                    if (!isRestoring) {
                        this.processTypingMessages(msgObj);
                    }

                    break;

                case MessageType.TYPE_CHAT_NEED_WAIT:
                    if (!isRestoring) {
                        this.isQueued = true;

                        if (this.$app.queuedMsgInAsync || !this.$app.isAsyncChat) {
                            this.addSystemMessage(this.$app.serviceQueued, SYSTEM_STATE.QUEUE_MSG);
                        }
                    }

                    break;

                case MessageType.TYPE_CHAT_AUTHORIZED:
                    const coversationId = this.getProperty(msgObj, KEY_TYPE.KEY_CONVERSATION_Id);
                    if (coversationId) {
                        this.$app.setConversationID(coversationId);
                    }
                    break;

                case MessageType.TYPE_CHAT_ACCEPTED:
                    const sdkInstance = this.$app.getSDKInstance();
                    const engagementId = this.getProperty(msgObj, KEY_TYPE.KEY_ENGAGEMENT_ID);
                    const agentId = this.getProperty(msgObj, KEY_TYPE.KEY_AGENT_ID);

                    if (engagementId) {
                        this.$app.setEngagementID(engagementId);
                    }

                    if (agentId) {
                        this.$app.setAgentID(agentId);
                    }

                    const aID = this.getProperty(msgObj, KEY_TYPE.KEY_MSG_AGENT_ALIAS) ? this.getProperty(msgObj, KEY_TYPE.KEY_MSG_AGENT_ALIAS) : agentId;

                    if (!isRestoring) {
                        if (this.isQueued) {
                            this.isQueued = false;
                            this.addSystemMessage(this.$app.agentAvailable, SYSTEM_STATE.QUEUE_MSG);
                        }

                        this.$app.persistValue(Constants.OPENERTS, Date.now());
                    }

                    this.updateMessagingTopBarStatus(sdkInstance.isVirtualAgent() ? STATUS_STATE.VA_AGENT : STATUS_STATE.LIVE_AGENT, aID);
                    sendDisclaimerAsDataPass(this.$app);
                    break;

                case MessageType.TYPE_CHAT_EXIT: {
                    let showInfoWidgetOnAgExit = false;
                    const senderName = this.getProperty(msgObj, KEY_TYPE.KEY_SENDER_NAME);
                    let displayText = this.getProperty(msgObj, KEY_TYPE.KEY_DISPLAY_TEXT);

                    if (this.$app.isAsyncChat) {
                        if (displayText) {
                            displayText = displayText.trim();
                        }

                        const forceClose = msgObj.getPropertyValueAsBoolean(KEY_TYPE.KEY_FORCED_CLOSE);

                        if (this.getProperty(msgObj, "conversation_resolved") !== "true") {
                            if (this.$app.showAsyncChatExitMsg) {
                                this.addSystemMessage(textGenerator(this.$app.agentExitText, msgObj.data) || displayText, SYSTEM_STATE.EXIT_MSG);
                            } else {
                                this.$app.shoutui.getTranscriptEl().hideTyping();
                            }

                            if (forceClose) {
                                showInfoWidgetOnAgExit = true;
                                this.disableFooter();
                            } else {
                                this.$app.disableEmailButtonWhenAsync();

                                if (this.getProperty(msgObj, KEY_TYPE.KEY_CHAT_REINIT)) {
                                    this.$app.reInitCIAPI();
                                }
                            }
                        } else {
                            if (this.$app.showAsyncChatResolvedMsg) {
                                this.addSystemMessage(textGenerator(this.$app.agentResolvedText, msgObj.data) || displayText, SYSTEM_STATE.EXIT_MSG);
                            } else {
                                this.$app.shoutui.getTranscriptEl().hideTyping();
                            }

                            this.$app.agentResolved();

                            if (!this.$app.getSDKInstance().getChatParams().isCiEnabledOnResolve() || forceClose) {
                                this.disableFooter();
                                showInfoWidgetOnAgExit = true;
                            } else {
                                this.$app.disableEmailButtonWhenAsync();
                            }
                        }
                    } else {
                        if (this.getProperty(msgObj, KEY_TYPE.KEY_AUTO_TRANSFER_IGNORED_CHATROOM) == "true") {
                            const text = this.getProperty(msgObj, KEY_TYPE.KEY_TY_LABEL) || this.$app.thankyouImageLabel;
                            this.addSystemMessage(text || displayText, SYSTEM_STATE.EXIT_MSG);
                            showInfoWidgetOnAgExit = false;
                        } else {
                            this.addSystemMessage(textGenerator(this.$app.agentExitText, msgObj.data) || displayText, SYSTEM_STATE.EXIT_MSG);
                            showInfoWidgetOnAgExit = true;
                        }

                        this.disableFooter();
                    }

                    if (showInfoWidgetOnAgExit) {
                        this.handleInfoWidgetOnAgExit(isRestoring, senderName, ts, isLast);
                    }

                    this.closeWebRtcConnectionOnChatExit();
                }

                    break;

                case MessageType.TYPE_CHAT_TRANSFER_RESPONSE:
                    if (this.$app.showTransferInitiateMessage) {
                        const displayText = this.getProperty(msgObj, KEY_TYPE.KEY_CLIENT_DISPLAY).trim(); // eslint-disable-line no-shadow
                        this.addSystemMessage(this.$app.agentInitiateTransfer || displayText, SYSTEM_STATE.TRANSFER_STARTED, true);
                    }

                    break;

                case MessageType.TYPE_CHAT_COMMUNICATION_QUEUE:
                    if ((this.$app.queuedMsgInAsync || !this.$app.isAsyncChat)) {
                        const text = this.getProperty(msgObj, KEY_TYPE.KEY_FINAL_TEXT);
                        const senderName = this.getProperty(msgObj, KEY_TYPE.QUEUE_AGENT_ALIAS);

                        if (this.$app.queueAsAgent && text) {
                            const message = new Message({
                                messageText: text,
                                isAuto: false,
                                name: senderName,
                                timestamp: ts, // eslint-disable-line object-shorthand
                            });
                            message.setRestore(isRestoring);
                            message.setAgentIndex(this.setAgentIndex(senderName));
                            this.$app.addToUI(message);
                        } else {
                            this.addSystemMessage(text, SYSTEM_STATE.QUEUE_MSG, this.$app.persistQueueMessages);
                        }

                        this.updateMessagingTopBarStatus(STATUS_STATE.QUEUE);
                    }

                    break;

                case MessageType.TYPE_CHATROOM_MEMBER_LOST: {
                    const displayText = (this.getProperty(msgObj, KEY_TYPE.KEY_CLIENT_DISPLAY) || this.getProperty(msgObj, KEY_TYPE.KEY_DISPLAY_TEXT)).trim(); // eslint-disable-line no-shadow

                    if (this.confAgents.length > 0) {
                        this.confAgents = this.confAgents.filter(alias => displayText.indexOf((alias)) !== -1);

                        if (this.confAgents.length == 1) {
                            this.updateMessagingTopBarStatus(STATUS_STATE.LIVE_AGENT, this.confAgents[0]);
                            this.confAgents = [];
                        } else if (this.confAgents.length > 1) {
                            const tAList = this.confAgents;
                            this.confAgents = this.confAgents.slice(0, this.confAgents.length - 1);
                            this.updateMessagingTopBarStatus(STATUS_STATE.CONFERENCE, tAList[tAList.length - 1]);
                        }
                    } else if (this.getProperty(msgObj, KEY_TYPE.KEY_TC_MODE) === Constants.TRANSFER) {
                        if (this.$app.showTransferLostMessage) {
                            this.addSystemMessage(this.$app.agentTransferLostText || displayText, SYSTEM_STATE.LOST, true);
                        }
                    } else if (this.$app.showMemberLostMessage) {
                        this.addSystemMessage(this.$app.agentLostText || displayText, SYSTEM_STATE.LOST, false);
                    }
                }

                    break;

                case MessageType.TYPE_CHATROOM_MEMBER_CONNECTED: {
                    const displayText = (this.getProperty(msgObj, KEY_TYPE.KEY_CLIENT_DISPLAY) || this.getProperty(msgObj, KEY_TYPE.KEY_DISPLAY_TEXT)).trim();
                    const alias = this.getProperty(msgObj, KEY_TYPE.KEY_MSG_AGENT_ALIAS)
                        ? this.getProperty(msgObj, KEY_TYPE.KEY_MSG_AGENT_ALIAS)
                        : this.getProperty(msgObj, KEY_TYPE.KEY_CHATROOM_MEMBER_NAME);

                    const agentId = this.getProperty(msgObj, KEY_TYPE.KEY_AGENT_ID);

                    if (this.getProperty(msgObj, KEY_TYPE.KEY_TC_MODE) === Constants.RECONNECTED) {
                        this.addSystemMessage(displayText, SYSTEM_STATE.TRANSFER_JOINED, false);
                    } else if (this.$app.showConferenceModeMessage && this.getProperty(msgObj, KEY_TYPE.KEY_TC_MODE) === Constants.CONFERENCE) {
                        this.updateMessagingTopBarStatus(STATUS_STATE.CONFERENCE, alias);
                        this.addSystemMessage(textGenerator(this.$app.conferenceModeText, msgObj.data) || displayText, SYSTEM_STATE.CONFERENCE, true);
                    } else if (this.$app.showTransferStatusMessage) {
                        this.updateMessagingTopBarStatus(this.$app.getSDKInstance().isVirtualAgent() ? STATUS_STATE.VA_AGENT : STATUS_STATE.LIVE_AGENT, alias);
                        this.addSystemMessage(textGenerator(this.$app.agentTransferStatusText, msgObj.data) || displayText, SYSTEM_STATE.TRANSFER_JOINED, true);
                    }

                    this.clearTypingTimeout();

                    const v3TO = this.getProperty(msgObj, KEY_TYPE.KEY_CONFIG_V3_TIMEOUT);
                    if (v3TO) {
                        this.$app.getSDKInstance().updateV3TO(v3TO);
                    }

                    if (agentId) {
                        this.$app.setAgentID(agentId);
                    }
                }

                    break;

                case MessageType.TYPE_NINA_COACH_CHAT_TAKE_OVER:
                    if (this.$app.showNinaCoachStatusMessage) {
                        const displayText = this.getProperty(msgObj, KEY_TYPE.KEY_DISPLAY_TEXT).trim(); // eslint-disable-line no-shadow
                        this.addSystemMessage(this.$app.ninaCoachStatusText || displayText, SYSTEM_STATE.CONFERENCE, true);
                    }

                    break;

                case MessageType.TYPE_CHAT_DENIED: {
                    const deniedMessageLabel = this.getProperty(msgObj, KEY_TYPE.KEY_TY_LABEL);
                    this.addSystemMessage(deniedMessageLabel || this.$app.serviceNotAvailable, SYSTEM_STATE.DENIED_MSG);
                    this.disableFooter();
                }

                    break;

                case MessageType.TYPE_CHAT_AUTHENTICATED_USER_RESPONSE:
                    //called when backend detects sync to async user flow
                    this.$app.setAsyncChat();
                    this.$app.getPrevConversation(true, true);
                    break;

                case MessageType.TYPE_CHAT_COBROWSE: {
                    const displayText = this.getProperty(msgObj, KEY_TYPE.KEY_MSG_TEXT);

                    const timestamp = ts;
                    const senderName = this.getProperty(msgObj, KEY_TYPE.KEY_SENDER_NAME) || this.getProperty(msgObj, KEY_TYPE.KEY_MSG_AGENT_ALIAS);
                    const message = new Message({
                        messageText: displayText,
                        name: senderName,
                        timestamp: timestamp, // eslint-disable-line object-shorthand
                    });
                    message.setAgentIndex(this.setAgentIndex(senderName));
                    this.$app.addToUI(message);
                }

                    break;

                case MessageType.TYPE_CLIENT_COMMAND: {
                    const cmd = this.getProperty(msgObj, KEY_TYPE.KEY_COMMAND_PARAM)
                        || this.getProperty(msgObj, KEY_TYPE.KEY_MSG_TEXT);
                    const { SHOW_UPLOAD_CMD, HIDE_UPLOAD_CMD } = CHAT_COMMANDS;
                    const commandText = cmd && cmd.toLowerCase();

                    if (!isRestoring && commandText && commandText.contains(SHOW_UPLOAD_CMD)) {
                        // displaying file upload if it is present in the command
                        new ModalMgr(this.$app).showFileUploadModal();
                    } else if (commandText && commandText.contains(HIDE_UPLOAD_CMD)) {
                        // Hide FileUpload if its visible
                        new ModalMgr(this.$app).hideFileUploadModal();
                    }
                }

                    break;

                // no default
            }
        }
    }

    /**
     * Method for additional handling of message when chat is minimized
     * @param isRestoring - boolean value representing if chat is being restored after page reload
     * @param msg - message object
     */
    setMsgOnMinimized(isRestoring: boolean, msg: any) {
        if (!isRestoring && this.$app.getIsMinimized()) {
            this.$app.getBridge().messageOnMinimized(msg);
        }
    }

    /**
     * method to show user an informational widget containing text and close chat button,
     * when agent exits the chat
     * @param {boolean | undefined} isRestoring received as param in calling function
     * @param {string} senderName derived from msgObj
     * @param {number} ts timestamp
     * @param {boolean | undefined} isLast received as param in calling function
     */
    handleInfoWidgetOnAgExit(isRestoring, senderName, ts, isLast) {
        const agentExitWidgetJSON = this.$app.getUIConfig().agentExitWidgetJSON;

        if (agentExitWidgetJSON) {
            this.displayDataMessage(agentExitWidgetJSON, Constants.EA, isRestoring,
                false, senderName, ts, isLast, false, false);
        }
    }

    getProperty(message, key) {
        return message.getPropertyValue(key);
    }

    /**
     *
     * @param {com.inq.flash.messagingframework.Message} message - message json object
     */
    processTypingMessages(message) {
        let typingMsg = "";
        let state;

        switch (this.getProperty(message, KEY_TYPE.KEY_TYPE)) {
            case ACTIVITY_AGENT_TYPING:
                typingMsg = this.$app.typingMsg;
                state = TYPING_STATE.TYPING;
                break;

            case ACTIVITY_AGENT_STOPPED_TYPING:

                /**
                 * hides typing animation element from chat window if showStoppedTyping property is false
                 */
                
                if (!this.$app.showStoppedTyping) {
                    let allMessages = this.$app.getRenderingEngine().getMessages();
                    let lastMessage = allMessages[allMessages.length - 1];
                    
                    if(lastMessage.bubbleType == BubbleType.TYPING_MESSAGE){
                        this.$app.getRenderingEngine().deleteLastItem();
                    }

                    return;
                }

                typingMsg = this.$app.stoppedTypingMsg;
                state = TYPING_STATE.STOPPED_TYPING;
                break;

            // no default
        }

        if (typingMsg) {
            const msg = new Message({
                bubbleType: BubbleType.TYPING_MESSAGE,
                messageText: typingMsg,
            });
            msg.setTypingState(state);
            this.$app.addToUI(msg);
        }
    }

    /**
     * Construct System bubble and inject it in the chat window
     * @param {text} text that gets set to System bubble messageText property
     * @param {state} state @see {@link SYSTEM_STATE} for the System bubble
     * @param {(true | false)} persist - to determine if the message stays in the chat window
     */

    addSystemMessage(text, state?, persist?) {
        addMessageBubbleToTranscriptInChatWindow(this.$app, text, state, persist);
    }

    /**
     * Disables Footer area from customer interaction
     */
    disableFooter() {
        this.$app.disableFooter(true);
    }

    /**
     * check if data message in historic transcript is hidden or locked
     * @param {Object} data - rich engine payload
     * @param {boolean} customerAction
     * @return {boolean}
     */
    isDataMsginHistoricHiddenLocked(data, customerAction) {
        if (!customerAction) {
            data.lockView = typeof data.historicLockView === "undefined" ? true : data.historicLockView;
        }
        return (customerAction ? data.receipt.historicHidden : data.historicHidden);
    }

    displayDataMessage(data, text, isRestoring, isAuto, senderName, timestmap, isLast, customerAction?, isAsync?, isExternalApp?) {
        const wt = customerAction ? data.receipt.widgetType : data.widgetType;
        let isHidden = false;
        const displayRichMsgOnRestore : any = data.displayInRestore ?? true;

        if (isRestoring && isAsync) {
            isHidden = this.isDataMsginHistoricHiddenLocked(data, customerAction);
        }

        const showData = !isRestoring || isLast == true || wt == RICH_WIDGET.TYPE_RECEIPT || displayRichMsgOnRestore;

        if (showData && !isHidden) {
            const widgetAction = data.widgetAction || "optional";

            if (widgetAction && !widgetAction.startsWith("optional") && (!isRestoring || isLast)) {
                this.$app.disableFooter(false);
            }

            const view = (customerAction ? data.receipt.widgetView : data.widgetView) || RICH_WIDGET.INLINE;

            if (view == "bubble") {
                const msg = new Message({
                    bubbleType: customerAction ? BubbleType.CUSTOMER_MESSAGE : BubbleType.AGENT_MESSAGE,
                    messageText: text,
                    isAuto: isAuto, // eslint-disable-line object-shorthand
                    name: senderName,
                    timestamp: timestmap, // eslint-disable-line object-shorthand
                });

                msg.setRichData(data);
                data.customerAction = customerAction;
                msg.setRestore(isRestoring);
                msg.setIsLast(isLast);
                if (isExternalApp) {
                    msg.setExternalVA();
                }

                if (isAsync) {
                    this.$app.renderEngine.addNewItemToTop(msg);
                } else {
                    this.$app.addToUI(msg);
                }
            } else if (view == RICH_WIDGET.INLINE) {
                let type = BubbleType.RICH_MESSAGE_OTHER;

                switch (wt) {
                    case RICH_WIDGET.TYPE_QR:
                        type = BubbleType.RICH_MESSAGE_QR;
                        break;

                    case RICH_WIDGET.TYPE_CARD:
                        type = BubbleType.RICH_MESSAGE_CARD;
                        break;

                    case RICH_WIDGET.TYPE_FORM:
                        type = BubbleType.RICH_MESSAGE_FORM;
                        break;

                    case RICH_WIDGET.TYPE_RECEIPT:
                        type = BubbleType.RICH_MESSAGE_RECEIPT;
                        break;

                    // no default
                }

                const msg = new Message({
                    bubbleType: type,
                    messageText: text,
                    isAuto: isAuto, // eslint-disable-line object-shorthand
                    name: senderName,
                    timestamp: timestmap, // eslint-disable-line object-shorthand
                });

                msg.setRichData(data);
                msg.setIsLast(isLast);
                msg.setRestore(isRestoring);
                msg.setAgentIndex(this.setAgentIndex(senderName));
                if (isExternalApp) {
                    msg.setExternalVA();
                }

                if (customerAction && !isRestoring && data.receipt.widgetAction
                    && data.receipt.widgetAction.endsWith(Constants.WIDGET_ACTION_REMOVE)) {
                    data.customerAction = true;
                    this.$app.updateLastMessage(msg);
                } else {
                    data.customerAction = customerAction;

                    if (isAsync) {
                        this.$app.renderEngine.addNewItemToTop(msg);
                    } else {
                        this.$app.addToUI(msg);
                    }
                }
            }
        } else if (isRestoring && (data.showMessageText || data.showMessageTextInRestore)) {
            return false;
        }
        return true;
    }

    /**
     * display the opener as rich media widget if it can be parsed as json
     * @param {string} opener
     * @param {Boolean} isRestoring
     * @param {Boolean} isVA
     * @param {String} agentAlias
     * @param {integer} openerTS
     * @return {Boolean}
     */
    displayOpenerRichMessage(opener, isRestoring, isVA, agentAlias, openerTS) {
        const openerMsg = opener.trim();

        if (openerMsg.startsWith("{") && openerMsg.endsWith("}")) {
            try {
                const richData = JSON.parse(decodeEntities(openerMsg));
                this.displayDataMessage(richData,
                    Constants.EA,
                    isRestoring,
                    isVA,
                    agentAlias,
                    openerTS,
                    false);
                return true;
            } catch (e) {
                // should continue with normal operation
                // eslint-disable-line no-empty
            }
        }
        return false;
    }

    /**
     *
     * @param {com.inq.flash.messagingframework.Message} resp
     * @return {Object} - Rich media widget JSON Object
     */
    getDataMessage(resp) { // eslint-disable-line class-methods-use-this
        const msgData = this.getProperty(resp, KEY_TYPE.KEY_MESSAGE_DATA);

        if (msgData) {
            const richData = JSON.parse(msgData);

            /**
             * if the json contains a property name webRTCEvent then redirect the logic to webrtc handler
             */
            if (this.isWebRTCData(richData)) {
                this.handleWebRTCEvent(richData.webRTCEvent);
                return null;
            }
            else if (this.isCommandData(richData)) {
                this.handleCommandData(richData.command);
                return null;
            }
            /**
             * if the json contains a property name richWidget then use that for rendering
             */
            return (richData.richWidget ? richData.richWidget : this.checkRichMediaProperties(richData));
        }
        return null;
    }

    checkRichMediaProperties(jsonData) {
        return (jsonData.receipt || jsonData.widgetType || jsonData.widgetView) ? jsonData : null;
    }

    isWebRTCData(messageData) {
        return messageData.webRTCEvent;
    }

    isCommandData(messageData) {
        return messageData.command;
    }

    setAgentIndex(alias) {
        let i = this.agents.indexOf(alias);

        if (i == -1) {
            this.agents.push(alias);
            i = this.agents.length - 1;
        }
        return i;
    }

    updateMessagingTopBarStatus(state, status?) {
        if (this.statusObj) {
            switch (state) {
                case STATUS_STATE.LIVE_AGENT:
                    this.$app.shoutui.updateStatus(status, this.statusObj.agentSubtext);
                    break;

                case STATUS_STATE.VA_AGENT:
                    this.$app.shoutui.updateStatus(status, this.statusObj.vaSubtext);
                    break;

                case STATUS_STATE.QUEUE:
                    this.$app.shoutui.updateStatus(this.statusObj.queueText, this.statusObj.queueSubText);
                    break;

                case STATUS_STATE.DISCONNECT:
                    this.$app.shoutui.updateStatus(this.statusObj.disconnectText, this.statusObj.disconnectSubtext);
                    break;

                case STATUS_STATE.CONFERENCE:
                    if (this.confAgents.length == 0) {
                        this.confAgents.push(this.agents[this.agents.length - 1]);
                    }

                    this.$app.shoutui.updateStatus([this.confAgents.join(","), this.statusObj.conferenceConjunction || " and ", status].join(""), this.statusObj.conferenceSubText);

                    if (this.confAgents.length >= 1) {
                        this.confAgents.push(status);
                    }

                    break;

                // no default
            }
        }
    }

    /**
     * compare the timestamp of last message of same time, new message time stamp should be greater than last
     * @param {int} timestamp
     * @param {string} text
     * @param {BubbleType} type
     * @return {boolean}
     */
    isDuplicateMessage(timestamp, text, type) {
        const msg = this.$app.getRenderingEngine().getLastMsgOfType(type);

        if (msg) {
            if (timestamp <= msg.getTimeStamp()) {
                if (msg.getMessageText() === text) {
                    return true;
                }
            }
        }
        return false;
    }

    /**
     * set the current window id
     * @param {String} windowId
     */
    setWindowId(windowId) {
        this.currentWindowId = windowId;
    }

    /**
     * Allows Agent to communicate webrtc call state
     * @param {Object} eventObj
     */
    handleWebRTCEvent(eventObj) {
        const layoutEl = this.$app.shoutui.getLayoutEl();
        const restore = this.$app.getRestoring();
        const callState = this.$app.getPersistedValue(Constants.CALL_STATE, CALL_STATE.PRE_CALL_SETUP);
        const reconnect = callState == CALL_STATE.ROOM_JOINED;
        const videoAudioCallInvitation = this.$app
            .getPersistedValue(Constants.VIDEO_AUDIO_CALL_INVITATION, 0);

        // eslint-disable-next-line default-case
        switch (eventObj.name) {
            case CALL_MESSAGE_TYPE.INVITATION:
                if (!restore || callState == CALL_STATE.PRE_CALL_SETUP) {
                    const videoContainer = layoutEl.displayVideoCallContainer(eventObj.data);
                    this.$app.getStateMgr().setState({ state: CHAT_STATE.PRECALL });
                    this.$app.persistValue(Constants.CALL_STATE, CALL_STATE.PRE_CALL_SETUP);

                    if (eventObj.data && eventObj.data.enabledCustomerCamera) {
                        this.$app.persistValue(Constants.VIDEO_AUDIO_CALL_INVITATION,
                            Constants.CALL_STATE_VIDEO_INVITE);
                    } else if (eventObj.data && eventObj.data.enableVoice) {
                        this.$app.persistValue(Constants.VIDEO_AUDIO_CALL_INVITATION,
                            Constants.CALL_STATE_VOICE_INVITE);
                    } else {
                        this.$app.persistValue(Constants.VIDEO_AUDIO_CALL_INVITATION, 0);
                    }

                    videoContainer.showPreCallView();
                } else if (callState == CALL_STATE.CALL_INVITED) {
                    this.showVideoContainer(layoutEl, eventObj.data, false);
                }

                break;

            case CALL_MESSAGE_TYPE.ROOM_READY:
                if (reconnect) {
                    if (videoAudioCallInvitation == Constants.CALL_STATE_VIDEO_INVITE) {
                        eventObj.data["enabledCustomerCamera"] = true;
                        eventObj.data["enableVoice"] = false;
                    } else if (videoAudioCallInvitation == Constants.CALL_STATE_VOICE_INVITE) {
                        eventObj.data["enableVoice"] = true;
                        eventObj.data["enabledCustomerCamera"] = false;
                    } else {
                        eventObj.data["enabledCustomerCamera"] = false;
                        eventObj.data["enableVoice"] = false;
                    }

                    this.callReconnectTimer = setTimeout(() => {
                        this.showVideoContainer(layoutEl, eventObj.data, true);
                        this.showVideoCallView(layoutEl, eventObj.data);
                        this.callReconnectTimer = null;
                    }, 1000);
                } else if (!restore) {
                    this.showVideoCallView(layoutEl, eventObj.data);
                }

                break;

            case CALL_MESSAGE_TYPE.CALL_ENDED:
                if (reconnect && this.callReconnectTimer != null) {
                    clearTimeout(this.callReconnectTimer);
                    this.callReconnectTimer = null;
                }

                if (!restore && layoutEl.getVideoContainer()) {
                    layoutEl.getVideoContainer().getVideoCallView().endCall();
                }

                break;

            case CALL_MESSAGE_TYPE.ROOM_AGENT_LEAVE:
                if (layoutEl.getVideoContainer()?.getVideoCallView()) {
                    layoutEl.getVideoContainer().getVideoCallView().showCallTransferState();
                }

                break;

            case CALL_MESSAGE_TYPE.ROOM_AGENT_JOIN:

                if (layoutEl.getVideoContainer()?.getVideoCallView()) {
                    layoutEl.getVideoContainer().getVideoCallView().hideCallTransferState();
                }

                break;
        }
    }

    showVideoContainer(layoutEl, data, reconnect) {
        const videoContainer = layoutEl.displayVideoCallContainer(data, reconnect);
        videoContainer.showVideoCallView();
    }

    showVideoCallView(layoutEl, data) {
        layoutEl.getVideoContainer().getVideoCallView().startCall(data);
    }

    clearTypingTimeout() {
        if (Timeout.exists(Constants.VA_TYPING_TIMER)) {
            Timeout.clear(Constants.VA_TYPING_TIMER);
        }
    }

    /**
     * Need to end web rtc connection or remove video call container when agent
     * exits from engagement witouht disconnecting call
     */
    closeWebRtcConnectionOnChatExit() {
        const layoutEl = this.$app.shoutui.getLayoutEl();

        // close web rtc connection when video call was in progress and agent leaves
        if (layoutEl.getVideoContainer()?.getVideoCallView?.()) {
            layoutEl.getVideoContainer().getVideoCallView().endCall();
        } else {
            // remove container before call engagement and agent leaves
            layoutEl.removeVideoCallContainer();
        }
    }

    handleCommandData(commandData) {
        if (commandData.event) {
            handleCommandEvent(commandData.event, this.$app.getSDKInstance());
        }
    }
}

export default GetMessageHandler;
